import React from 'react';
import PropTypes from 'prop-types';

import Footer from '../Footer';
import PublicWebsiteNav from '../PublicWebsiteNav';
import styles from './styles.sass';

// HOC for AMP page rendering
const AMPPage = ({ children, pathname, isAmpRoute }) => (
  <div className={styles.ampPage}>
    {isAmpRoute && <PublicWebsiteNav isAmp={isAmpRoute} pathname={pathname} />}
    {children}
    <Footer isAmp={isAmpRoute} />
  </div>
);

AMPPage.defaultProps = {
  pathname: null,
  isAmpRoute: false,
};
AMPPage.propTypes = {
  children: PropTypes.element.isRequired,
  pathname: PropTypes.string,
  isAmpRoute: PropTypes.bool,
};

export default AMPPage;
